// removed by extract-text-webpack-plugin
module.exports = {"achievements-page":"achievements-page","achievements-page__list":"achievements-page__list","achievements__cont":"achievements__cont","achievements__item":"achievements__item","date-item__link":"date-item__link","achievements":"achievements","date-item__preview":"date-item__preview","achievements__categories":"achievements__categories","item":"item","item__title":"item__title","text":"text","count":"count","is-open":"is-open"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_achievements.scss
// module id = 262
// module chunks = 0